<div class="title">{{ current }}</div>
<div class="crumbs" fxLayout="row" fxLayoutAlign="start center">
  <div *ngFor="let crumb of crumbs; index as i;" class="crumb" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon *ngIf="i > 0" class="chevron">chevron_right</mat-icon>
    <div *ngIf="isObject(crumb)" [routerLink]="crumb[1]" class="link">{{ crumb[0] }}</div>
    <div *ngIf="!isObject(crumb)" class="link">{{ crumb }}</div>
  </div>
  <div class="crumb current" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon *ngIf="crumbs.length" class="chevron">chevron_right</mat-icon>
    <div class="link">{{ current }}</div>
  </div>
</div>
